import React from 'react';
import styled from '@emotion/styled';
// --- external imports ------

import Asset from '../BaseAssets';
// --- parent imports ------

import { default as DefaultListItem } from './ListItem';
// --- local imports ------


function NewspaperList(props) {
	
	return (
		<ListContainer
			x={182}
			y={211}
			projection={LIST_CONTAINER_PROJECTION}
			data-testid={`${props['data-testid-prefix']}-available`}
		>
			{
				props.list.map((entry, index) => {
					const ListItemComp = props.renderer ? props.renderer?.(entry) : DefaultListItem;
					const testId = getEntryTestId(entry, props['data-testid-prefix']);
					return (
						<React.Fragment key={entry.name}>
							<ListItemComp
								entry={entry}
								onClick={props.onClick}
								isSelected={entry.name === props.selectedItem?.name}
								data-testid={testId}
							/>
							{
								(index !== props.list.length - 1) && (
									<Divider
										fontSize={1}
										projection={DIVIDER_PROJECTION}
									/>
								)
							}
						</React.Fragment>
					);
				})
			}
		</ListContainer>
	);
};

function getEntryTestId(entry, testIdPrefix) {
	const isEmployee = entry.jobType ?? false;

	let testId = `${testIdPrefix}-${entry?.detailsValues[0]}`;

	if (isEmployee) {
		testId = `${testId}-${entry?.detailsValues[1]}` 
	}

	return testId;
}
const LIST_CONTAINER_PROJECTION = {
	width: 483,
	height: 450
};

const DIVIDER_PROJECTION = {
	height: 2
};

const ListContainer = styled(Asset.TextContainer)`
	overflow-y: auto;
	
	&::-webkit-scrollbar {
		width: 0.4em;
	}

	&::-webkit-scrollbar-track {
		background-color: transparent;
	}

	&::-webkit-scrollbar-thumb {
		max-height: 0.5em;
		min-height: 0.5em;
		background-clip: padding-box;
		background-color: #31402d;
		border-radius: 5em;
		box-shadow: inset -1em -1em 0em rgba(0, 0, 0, 0.05),
			inset 1em 1em 0em rgba(0, 0, 0, 0.05);

		&:hover {
			background-color: #31402d;
		}
	}
`;

const Divider = styled(Asset.TextContainer)`
	margin-top: -1em;
	width: 100%;
	filter: blur(2em);
	background-color: rgba(31, 45, 34, 0.8);
`;

export default NewspaperList;
